import { render, staticRenderFns } from "./publish-product-setting.vue?vue&type=template&id=1b89e14b&scoped=true&"
import script from "./publish-product-setting.vue?vue&type=script&lang=js&"
export * from "./publish-product-setting.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-setting.vue?vue&type=style&index=0&id=1b89e14b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89e14b",
  null
  
)

export default component.exports